export const initModel = {
  first_name: "",
  last_name: "",
  avatar: "",
  email: "",
  mobile: "",
  title: "",
  name: "",
};
